module.exports = __webpack_public_path__ + "img/logo.d9f31628.png";